/**
 * Global app-frame wrapper — gives every page a rounded glass-card "device"
 * appearance with soft edges, top reflection and ambient red glow.
 *
 * Children are rendered as-is; the frame is purely visual.
 */
export default function AppFrame({ children }) {
  return (
    <div className="min-h-screen p-2 sm:p-4 md:p-5 lg:p-6">
      {/* Frame */}
      <div className="relative min-h-[calc(100vh-1rem)] sm:min-h-[calc(100vh-2rem)] md:min-h-[calc(100vh-2.5rem)] lg:min-h-[calc(100vh-3rem)] rounded-[20px] sm:rounded-[28px] border border-white/[0.12] bg-[#0a0a0a] shadow-[0_60px_120px_-20px_rgba(0,0,0,0.95),0_0_0_1px_rgba(229,9,20,0.06),inset_0_1px_0_rgba(255,255,255,0.08)] overflow-hidden">
        {/* Top edge highlight */}
        <span
          aria-hidden="true"
          className="pointer-events-none absolute inset-x-12 top-0 h-px bg-gradient-to-r from-transparent via-white/30 to-transparent"
        />
        {/* Subtle red ambient inside frame */}
        <div
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 opacity-60"
          style={{
            background:
              "radial-gradient(60% 40% at 50% 0%, rgba(229,9,20,0.06), rgba(229,9,20,0) 60%)",
          }}
        />
        {/* Single top-level <main> landmark for the entire routed content —
             satisfies axe landmark-one-main + region rules for every page. */}
        <main id="main" role="main">{children}</main>
      </div>
    </div>
  );
}
